 {
    "common": {
    "thisWeek": "Deze week",
    "lastWeek": "Vorige week",
    "lastNumberOfDays": "Laatste {numberOfDays} dagen",
    "thisMonth": "Deze maand"
    },
    "subAccounts": "Sub-accounts",
    "submitFeedback": "Feedback verzenden",
    "createSubAccount": "Een sub-account aanmaken",
    "viewScheduleReports": "Geplande rapporten bekijken",
    "searchSubAccount": "Zoeken op sub-account",
    "columns": "Kolommen",
    "sortBy": "Sorteren op",
    "selectColumns": "Kolommen Select",
    "maxColumns": "Max 8 kolommen op een Date",
    "applyColumns": "Kolommen toepassen",
    "activeUsers": "Actieve gebruikers",
    "appointments": "Afspraken",
    "contacts": "Contactpersonen",
    "emails": "Gmail",
    "textMessages": "Body berichten",
    "calls": "Oproepen",
    "submissions": "Inzendingen",
    "reviews": "Recensies",
    "sitesCreated": "Sites aangemaakt",
    "name": "Naam",
    "formSubmissions": "Formulierinzendingen",
    "surveySubmissions": "Enquête-inzendingen",
    "facebookFormSubmissions": "Facebook-formulierinzendingen",
    "funnels": "Trechters",
    "websites": "Websites",
    "forms": "Formulieren",
    "surveys": "Enquêtes",
    "highestFirst": "Max eerst",
    "lowestFirst": "Laagste eerst",
    "orderBy": "Via Sort",
    "noMoreLocations": "Geen Address meer found",
    "preparingReport": "We zijn uw rapport aan het voorbereiden…",
    "preparingReportDesc": "Sluit of vernieuw dit venster niet terwijl de export bezig is.",
    "outOf": "From",
    "subAccountsExported": "Sub-accounts geëxporteerd",
    "close": "Afsluiten",
    "scheduledForDeletion": "Scheduled voor verwijderen",
    "readyToSell": "Klaar om te verkopen",
    "closedWon": "Gesloten (gewonnen)",
    "wpSaleSuccessful": "Verkoop WordPress is succesvol",
    "wpNotSold": "WordPress nog niet verkocht",
    "yxtSaleSuccessful": "Verkoop Yext is succesvol",
    "yxtNotSold": "Yext nog niet verkocht",
    "saasSubInactive": "SaaS Subscription is Inactive",
    "saasSubTrialing": "SaaS Subscription wordt uitgeprobeerd",
    "saasSubActive": "SaaS Subscription is Dynamic",
    "emailRebillingActive": "Email Rebilling is Dynamic",
    "emailRebillingInactive": "Email Rebilling is Inactive",
    "twilioRebillingActive": "Twilio Rebilling is Dynamic",
    "twilioRebillingInactive": "Twilio Rebilling is Inactive",
    "wpRebillingActive": "Opnieuw factureren via WhatsApp is actief",
    "wpRebillingInactive": "Opnieuw factureren via WhatsApp is inactief",
    "saasModeActivated": "SaaS modus is Enabled",
    "paymentPending": "Betaling is in afwachting",
    "saasModeNotActivated": "SaaS modus is niet Enabled",
    "managedByLCPhone": "Manage Via LC Phone",
    "migrationToLCPhone": "Onder migratie naar LC Phone",
    "notManagedByLCPhone": "Not Manage Via LC Phone",
    "managedByLCEmail": "Manage Via LeadConnector Email System",
    "notMangedByLCEmail": "Not Manage Via LeadConnector Email System",
    "remainingWalletBalance": "Resterend saldo van de portemonnee van deze SaaS-locatie",
    "reports": "Rapporten",
    "switchToSubAccount": "Overschakelen naar sub-account",
    "manageClient": "Klant beheren",
    "subAccountDeletedIfChangedMind": "Dit sub-account wordt op {time} verwijderd, als u van gedachten bent veranderd",
    "subAccountDeletedInMinute": "Dit sub-account wordt in de komende minuut verwijderd",
    "changedMind": "If je je geest Dynamic hebt gemaakt",
    "clickHere": "click here",
    "subAccountPaused": "Dit sub-account is gepauzeerd. Uw klanten kunnen niet inloggen, maar het agentschap wel. Om dit account te hervatten",
    "subAccountRestricted": "Dit sub-account is gepauzeerd in afwachting van goedkeuring.",
    "subAccountVerificationPending": "Dit sub-account is gepauzeerd in afwachting van de e-mail- en telefoonverificatie door de admin van het sub-account.",
    "subAccountDeclined": "Dit sub-account is gepauzeerd vanwege een afgewezen goedkeuringsaanvraag. U kunt dit sub-account nog steeds hervatten vanuit ",
    "here": "hier.",
    "reviewAndResume": "om dit sub-account te beoordelen en te hervatten.",
    "incomingCalls": "Inkomende gesprekken",
    "outgoingCalls": "Uitgaande gesprekken",
    "totalTalktime": "Total gesprektijd",
    "incomingEmails": "Inkomende Gmail",
    "outgoingEmails": "Uitgaande Gmail",
    "incomingSms": "Inkomende Body berichten",
    "outgoingSms": "Uitgaande Body berichten",
    "contactsCreated": "Totaal aantal aangemaakte contactpersonen",
    "appointmentsBooked": "Totaal aantal geboekte afspraken",
    "totalFormSubmissions": "Total Form",
    "totalSurveySubmissions": "Total ingediende Survey",
    "totalFacebookFormSubmissions": "FacebookTotal -formulier voor aanmeldingen",
    "incomingGMBMessages": "Inkomende GBP-berichten",
    "outgoingGMBMessages": "Uitgaande GBP-berichten",
    "gmbMessages": "GBP-berichten",
    "fbMessages": "Facebook-berichten",
    "incomingFbMessages": "Inkomende Facebook-berichten",
    "outgoingFbMessages": "Uitgaande Facebook-berichten",
    "igMessages": "Instagram-berichten",
    "incomingIgMessages": "Inkomende Instagram-berichten",
    "outgoingIgMessages": "Uitgaande Instagram-berichten",
    "totalReviews": "Totaal aantal beoordelingen",
    "positiveReviews": "Positieve beoordelingen",
    "negativeReviews": "Negatieve beoordelingen",
    "back": "Terug",
    "selectDashboards": "Dashboards Select",
    "next": "Volgende",
    "backToSubAccounts": "Terug naar sub-accounts",
    "pauseSchedule": "Pause schedule",
    "resumeSchedule": "schedule Resume",
    "editSchedule": "Agenda bewerken",
    "addSchedule": "Agenda toevoegen",
    "selectReportToAdd": "Select rapporteert aan Add in de Email",
    "selectAll": "Select every",
    "pauseScheduleConfirm": "Weet je zeker dat je de schedule wilt Pause ?",
    "resumeScheduleConfirm": "Weet je zeker dat je de schedule wilt Resume ?",
    "tasks": "Taken",
    "conversations": "Communication",
    "users": "Operator",
    "dealOverview": "Overview Deal",
    "confirmAction": "Actie bevestigen",
    "yes": "Ja",
    "no": "Nee",
    "reportDetails": "Rapportdetails",
    "reportCreatedOn": "Created On melden",
    "searchByEmail": "Search Via Email",
    "lastActivity": "Laatste activiteit",
    "noRecords": "Geen records gevonden",
    "scheduleReport": "Gepland rapport",
    "schedule": "schedule",
    "save": "Opslaan",
    "emailSubject": "Subject Line",
    "frequency": "Frequentie",
    "daily": "Dagelijks",
    "weekly": "Wekelijks",
    "monthly": "Maandelijks",
    "nextScheduleDate": "Next schedule Date",
    "startingOn": "Starten On",
    "timeOfDay": "Date of Day",
    "reportsToTimezone": "Het rapport wordt verzonden in de tijdzone van het sub-account",
    "selectRecipients": "Ontvangers Select",
    "invalidEmail": "Voer een geldig e-mailadres in.",
    "testEmail": "Test Email",
    "selectTestRecipients": "Ontvangers van Test Select",
    "setupSubject": "Configure het Subject hierboven om het rapport te Test",
    "sendTest": "Upload Test",
    "scheduleSimilarSchedules": "Plan een soortgelijk rapport in voor andere sub-accounts",
    "accountSummary": "Accountoverzicht",
    "scheduleList": "Agendalijst",
    "subAccountName": "Naam sub-account",
    "nextRunDate": "Volgende uitvoeringsdatum",
    "reportSectionsAdded": "Rapportsecties toegevoegd",
    "status": "Status",
    "scheduleAction": "Agenda-actie",
    "cancel": "Annuleren",
    "pleaseWait": "Laden...",
    "confirm": "Bevestigen",
    "booked": "Geboekt",
    "confirmed": "Bevestigd",
    "showed": "Showed",
    "noShow": "Niet aanwezig",
    "cancelled": "Geannuleerd",
    "unread": "Ongelezen",
    "engagement": "Betrokkenheid",
    "reaction": "Reactie",
    "deliverySummary": "Leveringsoverzicht",
    "successfulDelivery": "Succesvolle levering",
    "opened": "Geopend",
    "clicked": "Geklikt",
    "replied": "Geantwoord",
    "unsubscribed": "Afgemeld",
    "complained": "Geklaagd",
    "failed": "Mislukt",
    "bounced": "Gestuiterd",
    "open": "Open",
    "won": "Gewonnen",
    "abandoned": "Verlaten",
    "lost": "Verloren",
    "sent": "Verzonden",
    "eject": "Uitwerpen",
    "delivered": "Afgeleverd",
    "faceBookLeadForm": "Facebook-leadformulier",
    "overdue": "Achterstallig",
    "reviewsReceived": "Ontvangen beoordelingen",
    "formBuilders": "Formulierbouwers",
    "switchToSaaS": "Schakel over naar SaaS",
    "numberOfContacts": "Totaal aantal contactpersonen",
    "numberOfAppointments": "Totaal aantal afspraken",
    "outreach": "Outreach",
    "notSubAccountUser": "Geen gebruiker van een sub-account",
    "searchSubAccName": "Zoek op de naam van een sub-account",
    "recipients": "Ontvangers",
    "scheduleCreated": "Schema voor e-mailrapporten gemaakt voor ",
    "scheduleUpdated": "Schema voor e-mailrapporten bijgewerkt voor ",
    "scheduleNotCreated": "Schema voor e-mailrapporten kon niet worden gemaakt voor",
    "scheduleNotUpdated": "Schema voor e-mailrapporten kon niet worden bijgewerkt voor",
    "total": "Totaal",
    "inbound": "Inkomend",
    "outbound": "Uitgaande",
    "totalEmails": "Totaal aantal e-mail",
    "inboundEmails": "Inkomende e-mails",
    "outboundEmails": "Uitgaande e-mails",
    "totalTextMessages": "Totaal aantal tekstberichten",
    "inboundTextMessages": "Inkomende tekstberichten",
    "outboundTextMessages": "Uitgaande tekstberichten",
    "totalCalls": "Totaal aantal oproepen",
    "inboundCalls": "Inkomende oproepen",
    "outboundCalls": "Uitgaande oproepen",
    "faceBookLeadFormSubmissions": "Inzendingen Facebook-leadformulier",
    "inboundGMBMessages": "Inkomende GBP-berichten",
    "outboundGMBMessages": "Uitgaande GBP-berichten",
    "totalIgMessages": "Totaal aantal Instagram-berichten",
    "inboundIgMessages": "Inkomende Instagram-berichten",
    "outboundIgMessages": "Uitgaande Instagram-berichten",
    "totalfbMessages": "Totaal aantal Facebook-berichten",
    "inboundfbMessages": "Inkomende Facebook-berichten",
    "outboundfbMessages": "Uitgaande Facebook-berichten",
    "sitesCreatedFunnels": "Sites aangemaakt - trechters",
    "sitesCreatedActiveFunnels": "Sites aangemaakt - actieve funnels",
    "sitesCreatedWebsites": "Sites aangemaakt - websites",
    "sitesCreatedActiveWebsites": "Sites aangemaakt - actieve websites",
    "sitesCreatedForms": "Sites aangemaakt - formulieren",
    "sitesCreatedActiveForms": "Sites aangemaakt - actieve formulieren",
    "sitesCreatedSurveys": "Sites aangemaakt - enquêtes",
    "sitesCreatedActiveSurveys": "Sites aangemaakt - actieve enquêtes",
    "googleReviews": "Google-beoordelingen",
    "facebookReviews": "Facebook-beoordelingen",
    "inboundCallDuration": "Duur van inkomende oproepen (uren)",
    "outboundCallDuration": "Duur uitgaande oproepen (uren)",
    "pleaseSelect": "Selecteren",
    "subAccountIsDeleted": "Dit sub-account is verwijderd",
    "subAccountIsPaused": "Dit sub-account is gepauzeerd",
    "success": "Gelukt",
    "error": "Fout",
    "testEmailSent": "Test Email sent",
    "testEmailNotSent": "Test Email kon niet worden sent",
    "reviewRequest": "Verzoeken om feedback",
    "pendingTransferDescription": "Andere agentschappen hebben gevraagd om sub-accounts aan u over te dragen.",
    "pendingTransferHeading": "U hebt lopende overdrachtsverzoeken voor sub-accounts.",
    "subAccountTransfer": "Overdrachten sub-accounts",
    "manageSubAccTransfer": "Beheer uw overdrachtsverzoeken voor sub-accounts",
    "subAccRequest": "Verzoeken voor sub-account {tabName}",
    "receive": "Inherit",
    "send": "Verzenden",
    "release": "Version",
    "requests": "{count} verzoeken",
    "subAccLimit": "De gebruikslimiet voor sub-accounts is bereikt.",
    "subAccPlanLimit": "U hebt 3 van de 3 sub-accounts gebruikt die zijn toegestaan binnen uw huidige abonnement.",
    "upgradeTime": "Het is tijd voor een upgrade!",
    "upgradeHigher": "Upgrade naar een hoger abonnement om de overdracht van het sub-account te accepteren.",
    "browse": "Abonnementen bekijken",
    "pendingTransferTitle": "Er loopt al een overdrachtsverzoek voor dit sub-account.",
    "unableTransfer": "Sub-account kan niet worden overdragen naar dit agentschap.",
    "unableEjectCancel": "Kan verzoek om het sub-account te verwijderen niet annuleren.",
    "EjectErrorDetails": "Het verzoek om het sub-account te verwijderen kan niet worden geannuleerd.",
    "hippaErrorDescription": "Dit sub-account is HIPAA-compatibel en kan niet worden overgedragen aan een niet-HIPAA-agentschap.",
    "pendingTransferErrorDescription": "Annuleer de bestaande overboekingsaanvraag voor dit sub-account voordat u een nieuwe aanmaakt.",
    "receivingAgency": "Ontvangend agentschap",
    "releasingAgency": "Uitgevend agentschap",
    "noOfContacts": "Totaal aantal contactpersonen",
    "requestedDate": "Gewenste datum",
    "action": "Actie",
    "cancelTransfer": "Overdracht annuleren",
    "decline": "Deny",
    "cancelTransferRequest": "Verzoek tot overdracht van sub-account annuleren?",
    "cancelEjectRequest": "Verzoek tot afstoten van sub-account annuleren?",
    "cancelRequestDescription": "Het ontvangende agentschap ziet dit overdrachtsverzoek niet meer en het sub-account {name} wordt niet overgedragen.",
    "cancelEjectRequestDescription": "De geselecteerde gebruiker kan geen nieuw agentschap meer aanmaken vanuit het sub-account {name}.",
    "declineRequest": "Verzoek tot overdracht van sub-account afwijzen?",
    "declineRequestDescription": "Het verzoek wordt afgewezen en het sub-account {name} wordt niet overgedragen aan uw agentschap.",
    "approveTransfer": "Overdracht van sub-account naar uw agentschap goedkeuren?",
    "approveTransferDescription": "Sub-account {name} wordt overgedragen aan uw agentschap.",
    "transferNow": "Nu overdragen",
    "cancelNow": "Nu annuleren",
    "transferErrorDetails": "Dit sub-account kan niet worden overgedragen.",
    "cancelRequest": "Aanvraag annuleren",
    "received": "Ontvangen",
    "approve": "Goedkeuren",
    "goBack": "Ga terug",
    "done": "Voltooid",
    "subAccountTransferred": "Het sub-account is overgedragen!",
    "subAccountTransferDescription": "Hoewel het sub-account is overgedragen, kan het nog 10-15 minuten duren voordat sommige activa, zoals gebruikers, telefoonnummers, Mailgun-accounts en Yext-vermeldingen, op de bestemming zichtbaar zijn.",
    "activeSubscriptionsAlert": "De Location heeft een Dynamic Subscription. Cancel every Subscription Voor Blind Transfer the Location. of Subscription List {subscriptions} {Dynamic}",
    "isSaasEnabled": "SaaS ingeschakeld",
    "typeToSearch": "Typ om te zoeken",
    "dateAdded": "Datum toegevoegd",
    "emailEngagement": "E-mailbetrokkenheid",
    "emailReaction": "E-mailreactie",
    "emailDeliverySummary": "Overzicht e-maillevering",
    "facebook": "Facebook",
    "sms": "Sms",
    "instagram": "Instagram",
    "accountSummarySubAccount": "Accountoverzicht - {subAccountName}",
    "test": "Test",
    "scheduleExists": "Agenda bestaat",
    "aToZ": "A - Zo",
    "zToA": "Z - A",
    "onlyAdminUsersCanAddNewSubAccounts": "Alleen admins kunnen nieuwe sub-accounts toevoegen.",
    "locationName": "Locatienaam",
    "transferCompleted": "Het overdrachtsverzoek voor deze locatie is al verwerkt. Vernieuw de pagina.",
    "unauthorizedTransfer": "Je bent niet geautoriseerd om deze Action uit te voeren. Alleen Agency kunnen deze Action uitvoeren.",
    "bulkLocationTransfer": "Sub-accounts in bulk overdragen",
    "singleRequest": "Enkel verzoek",
    "bulkRequest": "Bulkverzoek",
    "backToLocationTransfer": "Terug naar locatieoverdracht",
    "initiateBulkTransfer": "Sub-accounts in bulk overdragen starten",
    "initiateBulkTransferDescription": "Selecteer de sub-accounts die u wilt overdragen, of voer hun ID's in, gescheiden door komma's.",
    "subAccountId": "Sub-account-ID",
    "selectFromList": "Selecteer uit de lijst",
    "addManually": "Handmatig toevoegen",
    "accountsSelected": "{count} geselecteerd",
    "selectAllSubAccounts": "Select every",
    "removeAll": "Alles verwijderen",
    "addManualLocations": "Voeg locatie-ID's toe, gescheiden door komma's",
    "manualAllLocationIds": "Location ID's of de sub-account You wish to Transfer, Separated Via komma's.",
    "enterLocationIds": "Voer locatie-ID's in",
    "selectSubAccounts": "Selecteer sub-accounts en draag deze over naar een bestaand agentschap",
    "subAccountTransferWarning": "every sub-accountactiva en Operator krijgen Download.",
    "proceed": "Doorgaan",
    "bulkRequestSubmitted": "Verzoek voor bulkoverdracht ingediend",
    "bulkRequestSubmittedDescription": "De overdracht van elk sub-account vindt plaats zodra het ontvangende agentschap het overdrachtsverzoek accepteert. U kunt de status van het verzoek volgen op de pagina '{pagename}'. (op voorwaarde dat ze in aanmerking komen)",
    "bulkTransferRequestFailed": "Het verzoek voor bulkoverdracht is mislukt",
    "errorLocations": "Sub-accounts met fout",
    "viewDetails": "Details bekijken",
    "somethingWrong": "Er is iets misgegaan. Probeer het opnieuw.",
    "confirmBulkRequest": "Verzoek voor bulkoverdracht bevestigen?",
    "bulkTransferAccounts": "'{count}' geselecteerde sub-accounts in bulk overdragen?",
    "confirmDetails": "Controleer de details voordat u ze overdraagt.",
    "transferConsent": "Ik heb Read en begrepen bovenstaande handleiding en Consent op every van de beperkingen.",
    "transferInfo": "De overdracht van sub-accounts is afhankelijk van de acceptatie door het ontvangende agentschap.",
    "receivingRelNo": "Relatienummer van het ontvangende agentschap",
    "enterRelNo": "Relatienummer invoeren",
    "transferConfirmation": "Na het voltooien van deze Action worden de Bulk Transfer Requests sent naar het Received Agency ({ relNo }). every sub-Account You Selected wordt Download zodra het Received Agency deze heeft geaccepteerd. Note : deze Action is onomkeerbaar voor every sub-account die is opgenomen in de Transfer.",
    "confirmPassword": "Bevestigen Via het password in te typen",
    "enterPassword": "Wachtwoord invoeren",
    "requestTransfer": "Overdracht aanvragen",
    "confirmTransfer": "Overdracht bevestigen",
    "notNow": "Niet nu",
    "invalidRelNo": "Ongeldig relatienummer",
    "invalidPassword": "Invalid password.",
    "searchSubAccounts": "Sub-accounts zoeken",
    "searchSubAccountsId": "Sub-account-ID zoeken",
    "takeAction": "Actie ondernemen",
    "sub_account_details": "Details van sub-account:",
    "no_of_contacts": "Totaal aantal contactpersonen",
    "transfer_status": "Status van overdracht",
    "error_info": "Foutinformatie",
    "bulk_transfer_status": "Status bulkoverdracht sub-accounts",
    "pending": "In afwachting",
    "processed": "Verwerkt",
    "reject_all": "Alles afwijzen",
    "accept_all": "Alles accepteren",
    "cancel_all": "Alles annuleren",
    "clearAll": "Alles wissen",
    "refresh": "Vernieuwen",
    "rejected": "Denied",
    "decline_transfer": "Overdracht weigeren",
    "decline_bulk_transfer": "Verzoek tot bulkoverdracht van sub-accounts weigeren?",
    "decline_bulk_transfer_description": "Het verzoek wordt afgewezen en de {length} sub-accounts worden niet overgedragen aan uw agentschap.",
    "accept_bulk_transfer": "Verzoek tot bulkoverdracht van sub-accounts accepteren?",
    "accept_bulk_transfer_description": "Het verzoek wordt geaccepteerd en de {length} sub-accounts worden overgedragen aan uw agentschap.",
    "cancel_bulk_transfer": "Bulkoverdracht annuleren?",
    "cancel_bulk_transfer_description": "Weet u zeker dat u deze bulkoverdracht van {length} sub-accounts naar '{name}' wilt annuleren?",
    "consent_sub_account_transfer": "Read en Consent naar {link}",
    "sub_account_transfer_guidelines": "Richtlijnen voor de overdracht van sub-accounts",
    "valid_rel": "Voer een geldig number in",
    "something_went_wrong": "Er is iets misgegaan. Probeer het opnieuw.",
    "export": "Exporteren",
    "export_success": "De gegevens waar You om hebt gevraagd, worden verwerkt. You Inherit een Email met de gegevens in een Date.",
    "export_failed": "De gevraagde gegevens You kunnen niet worden verwerkt. Try again .",
    "selectAllError": "U kunt slechts 1000 sub-accounts tegelijk selecteren.",
    "max1000": "(Max. 1000)",
    "subAccountCount": "Aantal sub-accounts",
    "whatsapp": "WhatsApp",
    "scheduleBulkPauseConfirm": "Weet je zeker dat je Pause {count} rapporten wilt?",
    "scheduleBulkResumeConfirm": "Weet You zeker dat You {count} rapporten wilt Resume ?",
    "resume": "Hervatten",
    "pause": "Onderbreken",
    "resumeSelected": "Resume",
    "pauseSelected": "Pause Selected",
    "bulkActions": "Bulk actions",
    "xReportsSelected": "{count} rapporten geselecteerd",
    "selectAllXReports": "Alle {count} rapporten selecteren",
    "scheduleStatus": "Status planning",
    "scheduleSearchPlaceholder": "Zoeken op e-mailadres of locatienaam",
    "subAccountsPerPage": "Sub-accounts per pagina",
    "previous": "Vorige",
    "scheduleBulkAction": "Bulkactie plannen",
    "all": "Alle",
    "active": "Actief",
    "paused": "Onderbroken",
    "scheduleUpdatedSuccessfully": "schedule Success Updated",
    "saveChanges": "Wijzigingen opslaan",
    "pauseSchedulesTitle": "Pauzeer actieve geplande rapporten",
    "pauseSchedulesDescription": "click voor Pause now Actief rapporten.",
    "pauseSchedulesAlert": "Dit heeft alleen invloed op Account die now Dynamic zijn.",
    "pauseAllSchedulesBtnText": "Alle geplande rapporten pauzeren",
    "autoScheduleTitle": "Automatisch plannen voor nieuwe accounts",
    "autoScheduleLabel": "Maak automatisch geplande rapporten aan wanneer een nieuw sub-account wordt toegevoegd.",
    "autoScheduleAlert": "You If uw Disable handmatig Configure voor een new Account.",
    "autoScheduleEnabledForNewAccounts": "Auto-inplannen Enabled voor new Account",
    "autoScheduleDisabledForNewAccounts": "Auto Inplannen Disabled voor new Account",
    "deleted": "Verwijderd",
    "locationPaused": "Locatie gepauzeerd",
    "scheduleSettingsModalTitle": "schedule Report Settings",
    "selectAllSchedules": "every Schedule Select",
    "selectScheduleForLocation": "schedule Select voor {location}",
    "openSettings": "Open Settings",
    "resumeScheduleForLocation": "Resume schedule voor {location}",
    "pauseScheduleForLocation": "schedule Pause voor {location}",
    "actions": "Acties",
    "deselectAll": "Deselecteer every",
    "scheduleBulkActionResumeSuccess": "Bulk in Activatie — Disabled naar new On",
    "scheduleBulkActionPauseSuccess": "Rapporten pauzeren – wacht even voordat u verdere acties onderneemt.",
    "bulkActionCreationError": "Er wordt nog een bulkactie uitgevoerd. Probeer het straks nog eens.",
    "bulkActionInProgress": "Bulk al in Action",
    "scheduledReports": "Scheduled rapporten",
    "scheduleBulkActionCompleted": "Bulk Action Done succesvol",
    "pauseAllSchedulesModalTitle": "Rapporten pauzeren?",
    "pauseAllSchedulesModalText": "Hiermee worden alle actieve geplande rapporten voor sub-accounts gepauzeerd.",
    "addLocationIdsPlaceholder": "Voeg locatie-ID's toe die u wilt overdragen...",
    "helloWorld": {
      "count": "Aantal is {count}",
      "editIntro": "Bewerken",
      "editAction": "Om HMR te testen",
      "checkOut": "Bekijk",
      "officialStarter": ", de officiële Vue + Vite starter",
      "install": "Installeren",
      "installDescription": "In uw IDE voor een betere DX",
      "learnMore": "Klik op de logo's van Vite en Vue voor meer informatie"
    },
    "home": {
      "testMessage": "Hallo! This is een test homepage!"
    },
    "reports": {
      "incoming": "Binnenkomend",
      "outgoing": "Uitgaand",
      "duration": "Duur",
      "contactsCount": "Totaal aantal contactpersonen",
      "appointmentsCount": "Totaal aantal afspraken",
      "formSubmissions": "Formulierinzendingen",
      "surveySubmissions": "Enquête-inzendingen",
      "facebookFormSubmissions": "Facebook-formulierinzendingen",
      "funnels": "Trechters",
      "websites": "Websites",
      "forms": "Formulieren",
      "surveys": "Enquêtes",
      "gbpMessages": "GBP-berichten",
      "facebookMessages": "Facebook-bericht",
      "instagramMessages": "Instagram-berichten",
      "reviews": "Recensies",
      "positives": "Positieven",
      "negatives": "Negatieven"
    },
    "timeOptions": {
      "00": "00:00 uur",
      "01": "01:00 uur",
      "02": "02:00 uur",
      "03": "03:00 uur",
      "04": "04:00 uur",
      "05": "05:00 uur",
      "06": "06:00 uur",
      "07": "07:00 uur",
      "08": "08:00 uur",
      "09": "09:00 uur",
      "10": "10:00 uur",
      "11": "11:00 uur",
      "12": "12:00 uur",
      "13": "13:00 uur",
      "14": "14.00 uur",
      "15": "15:00 uur",
      "16": "16:00 uur",
      "17": "17:00 uur",
      "18": "18:00 uur",
      "19": "19:00 uur",
      "20": "20:00 uur",
      "21": "21:00 uur",
      "22": "22:00 uur",
      "23": "23:00 uur"
    },
    "transferStatus": {
      "pending": "In afwachting",
      "processed": "Verwerkt",
      "canceled": "Geannuleerd",
      "cancelled": "Geannuleerd",
      "completed": "Voltooid",
      "rejected": "Geweigerd",
      "failed": "Mislukt",
      "payment_pending": "Betaling in afwachting"
    }
    }
